import React, { Button, Component, useState } from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import WaitDialog from "../../../widgets/WaitDialog";

import GetCorsi from "../../../services/getCorsi";
import getStudenti from "../../../services/getStudentiForBilling";
import getPianoPagamentiCorso from "../../../services/getPianoPagamentiCorso";
import GestioneRate from "../../../widgets/GestioneRateWidget";
import getPianoPagamentiCorsoStudenti from "../../../services/getPianoPagamentiCorsoStudenti";
import addPianoPagamentiCorsoStudenti from "../../../services/addPianoPagamentiCorsoStudenti";
import deleteRateStatus from "../../../services/deleteRateStatus";
import addRataStatus from "../../../services/addRataStatus";
import getRataStatus from "../../../services/getRataStatus";
import { Prompt } from "react-router";

export default class EditCorso extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.options = [{ value: "All", label: "All" }];

    this.selectRef = React.createRef();

    this.state = {
      unsavedChanges: false,
    };
  }

  componentDidMount() {
    //window.addEventListener('beforeunload', this.alertUser);
  }

  componentWillUnmount() {
    //window.removeEventListener('beforeunload', this.alertUser)
  }

  alertUser(e) {
    /*if (this.state.unsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
    }*/
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });
    const currentStudente = cookies.get("currentStudent", { path: "/" });

    this.corsi = await GetCorsi(username, token);
    this.corso = this.corsi.find((c) => c.id == currentCourse);
    this.studenti = await getStudenti(username, token);
    this.studente = this.studenti.find((s) => s.id == currentStudente);
    this.studenti = this.studenti.filter((s) => {
      if (!s.corsi) return false;

      // Gestisce diversi formati: singolo ID, con virgola, con punto e virgola
      const corsiList = s.corsi
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      return corsiList.includes(currentCourse);
    });

    this.pianoRateCorso = await getPianoPagamentiCorso(
      username,
      token,
      this.corso.id,
    );
    this.pianoRateCorsoStudente = await getPianoPagamentiCorsoStudenti(
      username,
      token,
      this.corso.id,
      this.studente.id,
    );

    this.rataStatus = await getRataStatus(
      username,
      token,
      this.corso.id,
      this.studente.id,
    );

    console.log("rataStatus", this.rataStatus);

    this.setState({
      costo: "0",
    });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    this.searchCols = ["nome", "cognome", "mail"];

    if (this.corso == undefined) return <div></div>;

    this.custom =
      this.pianoRateCorsoStudente != undefined &&
      this.pianoRateCorsoStudente != null;

    return (
      <>
        <Prompt
          when={this.state.unsavedChanges}
          message="Hai delle modifiche ancora non salvate. Vuoi davvero lasciare la pagina?"
        />
        <div id={Math.random()}>
          <LoadingOverlay
            active={this.state.isLoading}
            styles={{
              content: (base) => ({
                position: "relative",
                width: "100%",
                top: "200px",
              }),
            }}
            spinner
            text={"Loading your content..."}
          >
            <PageTitle
              title={
                "Piano rateale " +
                this.studente.nome +
                " " +
                this.studente.cognome
              }
            />

            <div
              style={{
                border: "1px solid #888",
                padding: "10px",
                marginBottom: "10px",
                fontWeight: "bold",
              }}
            >
              {/* Mostra SEMPRE il corso originale del piano rateale come titolo principale */}
              <div>
                {this.pianoRateCorsoStudente &&
                this.pianoRateCorsoStudente._corsoCambiato == 1 &&
                this.pianoRateCorsoStudente._nomeCorsoOriginale
                  ? this.pianoRateCorsoStudente._nomeCorsoOriginale
                  : this.corso.name}
              </div>
              <div>{this.studente.nome + " " + this.studente.cognome}</div>
              {/* Mostra badge con il corso attuale se è stato spostato */}
              {this.pianoRateCorsoStudente &&
                this.pianoRateCorsoStudente._corsoCambiato == 1 &&
                this.pianoRateCorsoStudente._nomeCorsoOriginale &&
                this.pianoRateCorsoStudente._nomeCorsoOriginale !==
                  this.corso.name && (
                  <div
                    style={{
                      marginTop: "8px",
                      padding: "6px 10px",
                      backgroundColor: "#e8f5e9",
                      border: "1px solid #28a745",
                      borderRadius: "4px",
                      fontSize: "13px",
                      color: "#155724",
                    }}
                  >
                    Corso attuale: {this.corso.name}
                  </div>
                )}
            </div>

            <GestioneRate
              piano={
                this.pianoRateCorsoStudente != undefined
                  ? this.pianoRateCorsoStudente
                  : this.pianoRateCorso
              }
              custom={this.custom}
              isStudent={true}
              studentObj={this.studente}
              corso={this.corso}
              onModification={() => {
                this.setState({ unsavedChanges: true });
              }}
              onRataSalvata={() => {
                // Quando una singola rata viene salvata con successo, non consideriamo
                // questo come modifiche non salvate
                this.setState({ unsavedChanges: false });
              }}
              onSalva={async (costo, rate, rataStatus) => {
                // Preserva i metadata esistenti (incluso corso_origine per tracciare il corso originale)
                var existingMetadata =
                  this.pianoRateCorsoStudente &&
                  this.pianoRateCorsoStudente.metadata
                    ? this.pianoRateCorsoStudente.metadata
                    : null;

                var json = {
                  costo: costo,
                  rate: rate,
                };

                // Se esistono metadata (es. corso_origine), li preserva
                if (existingMetadata) {
                  json.metadata = existingMetadata;
                }

                if (this.custom == false) {
                  if (window.confirm("Passare al piano custom?") == false)
                    return;
                }

                const cookies = new Cookies();
                const username = cookies.get("username", { path: "/" });
                const token = cookies.get("token", { path: "/" });
                let res = await addPianoPagamentiCorsoStudenti(
                  username,
                  token,
                  this.corso.id,
                  this.studente.id,
                  JSON.stringify(json),
                );

                if (res.result === "KO") {
                  alert(
                    "Si è verificato un errore durante il salvataggio dei dati",
                  );
                  return;
                }

                await deleteRateStatus(
                  username,
                  token,
                  this.corso.id,
                  this.studente.id,
                );
                var done = true;
                for (var rata of rataStatus) {
                  let response = await addRataStatus(
                    username,
                    token,
                    rata.id_corso,
                    rata.id_studente,
                    rata.data,
                    rata.importo,
                    rata.status,
                    rata.files,
                    rata.note,
                  );
                  if (response.result === "KO") {
                    done = false;
                  }
                }

                if (done) {
                  this.custom = true;
                  this.setState({ unsavedChanges: false });
                  alert("Salvataggio effettuato");
                  return;
                }

                alert(
                  "Si è verificato un errore durante il salvataggio dei dati",
                );
              }}
            />

            <WaitDialog
              show={this.state.waitDialogVisible}
              key={Math.random()}
              index={this.state.index}
            />
          </LoadingOverlay>
        </div>
      </>
    );
  }
}
